import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Pagination from 'modules/common/components/Pagination';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

const pageFilter = {
  page: 1,
  sort_by: 'desc',
  order_by: 'id',
};

function RoleManagementContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  selectedRole,
  showRole,
  roleInfo,
  handleAddPermissionModal,
  handleRemovePermission,
  getPermissionList,
  permissionList,
  permissionListPager,
  permissions,
}) {
  const [pageFilterData, setFilterPageData] = useState(pageFilter);
  const handleChangePage = page => {
    setFilterPageData({
      ...pageFilterData,
      page,
    });
  };

  useEffect(() => {
    if (_.isEmpty(selectedRole)) return;
    showRole(selectedRole);
    getPermissionList(selectedRole);
  }, []);
  useEffect(() => {
    if (_.isEmpty(selectedRole)) return;
    showRole(selectedRole);
    getPermissionList(selectedRole);
  }, [selectedRole]);
  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          {Acl(permissions, ['VIEW ROLE MANAGEMENT']) && (
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
            >
              Add&nbsp;
              <i className="fas fa-plus" />
            </button>
          )}
        </div>
      </div>
      {!_.isEmpty(roleInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row bg-white">
                <div className="col-10">
                  <h3 className="">{_.get(roleInfo, 'attributes.name')}</h3>
                </div>
                <div className="col-2 d-flex">
                  <div className="ml-auto">
                    {Acl(permissions, ['VIEW ROLE MANAGEMENT']) && (
                      <div>
                        <button
                          type="button"
                          className="btn-blank"
                          onClick={handleEdit(roleInfo)}
                        >
                          <i className="far fa-edit icon-edit" />
                        </button>
                        <button
                          type="button"
                          className="btn-blank"
                          onClick={handleRemove(roleInfo)}
                        >
                          <i className="far fa-trash-alt icon-delete" />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-12">
                  <div className="right-section-content my-1">
                    <div className="d-flex flex-row align-items-center mb-3">
                      <div className="px-3">
                        <h3 className="m-0">Permission</h3>
                      </div>
                      <div className="px-3 ml-auto">
                        {Acl(permissions, ['VIEW ROLE MANAGEMENT']) && (
                          <button
                            type="button"
                            className="btn btn-secondary btn-round font-weight-bold px-4 ml-auto"
                            onClick={handleAddPermissionModal(
                              selectedRole,
                              permissionList
                            )}
                          >
                            Add Permission <i className="fas fa-plus" />
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-row">
                      <div className="table-container w-100 mx-3">
                        <table className="w-100">
                          <tbody>
                            {permissionList.map(item => (
                              <tr key={item.id} className="top-border">
                                <td className="td-item pl-3">
                                  {_.get(item, 'attributes.name') || '--'}
                                </td>
                                <td className="pr-4">
                                  <div className="d-flex">
                                    <button
                                      type="button"
                                      className="btn-blank ml-auto"
                                      onClick={handleRemovePermission(
                                        selectedRole,
                                        item
                                      )}
                                    >
                                      <i className="far fa-trash-alt icon-delete" />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {permissionList && permissionList.length < 0 && (
                        <Pagination
                          onChange={handleChangePage}
                          data={permissionListPager}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

RoleManagementContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  handleAddPermissionModal: PropTypes.instanceOf(Function).isRequired,
  handleRemovePermission: PropTypes.instanceOf(Function).isRequired,

  showRole: PropTypes.instanceOf(Function).isRequired,
  roleInfo: PropTypes.instanceOf(Object).isRequired,
  selectedRole: PropTypes.string.isRequired,
  getPermissionList: PropTypes.instanceOf(Function).isRequired,
  permissionList: PropTypes.instanceOf(Array).isRequired,
  permissionListPager: PropTypes.instanceOf(Object).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  roleInfo: _.get(api, `${c.GET_SELECTED_ROLE}.item`) || {},
  selectedRole: _.get(match, 'params.roleId') || '',
  permissionList: _.get(api, `${c.GET_PERMISSION}.list`) || [],
  permissionListPager: _.get(api, `${c.GET_PERMISSION}.pager`) || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RoleManagementContent);
